import React from 'react';
import { Link } from 'react-router-dom';
import IsoCertificateSection from '../iso/IsoCertificateSection';
import './home-overview.css';

function HomeOverview() {
    return (
        <>
            {/* Solutions Overview Section */}
            {/* Solutions Overview CTA Section */}
            <section className="vrm-cta-banner">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="vrm-cta-banner__content wow fadeInUp" data-wow-delay=".2s">
                                <p className="pre-title">Applied AI · Toward Business Superintelligence</p>
                                <h1 className="title">Enterprise AI Built Around Your Workflows</h1>
                                <p className="desc">
                                    We build Generative AI systems, conversational voice agents and custom machine learning software that read, reason and act across your business, moving every team closer to superintelligent operations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="vrm-hero__cards--two-columns" style={{ marginBottom: '80px' }}>
                    {[

                        {
                            id: 2,
                            icon: "assets/images/service/icon/02.svg",
                            title: "AI Development Services",
                            desc: "Building custom, high-performance AI solutions. From intelligent chatbots to machine learning models, we transform your complex business requirements into scalable, secure, and production-ready applications.",
                            link: "/solutions/ai-development-services",
                            bgImage: "assets/images/about/2.webp"
                        },
                        {
                            id: 3,
                            icon: "assets/images/service/icon/04.svg",
                            title: "AI Chatbot Development",
                            desc: "Developing intelligent, conversational AI chatbots. We design custom NLP solutions, automate customer support, and deploy smart virtual assistants to enhance engagement across all channels.",
                            link: "/solutions/ai-chatbot-development",
                            bgImage: "assets/images/about/04.webp"
                        }
                    ].map((product, index) => (
                        <div key={product.id} className="vrm-product-card wow fadeInUp" data-wow-delay=".3s">
                            <div className="vrm-product-card-bg">
                                <img src={product.bgImage} 
                                    alt={product.title} 
                                    fetchpriority={index === 0 ? "high" : "auto"}
                                    decoding={index === 0 ? "async" : undefined}
                                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} 
                                    width="346" 
                                    height="346" 
                                    loading={index === 0 ? undefined : "lazy"} />
                            </div>
                            <div className="vrm-product-card__content">
                                <div className="vrm-hero__icon">
                                    <img src={product.icon} alt={product.title} loading="lazy" />
                                </div>
                                <h2>{product.title}</h2>
                                <p>{product.desc}</p>
                                <Link className="vrm-btn-detail" to={product.link}>
                                    Know More<i className="fas fa-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Certified for Excellence Section — Placed directly below Product & Support / Know More, and ABOVE Products Highlight */}
            <IsoCertificateSection />

            {/* Products Highlight Section */}
            <section className="vrm-products-highlight">
                <div className="container">
                    {/* Workflow Section */}
                    <div className="vrm-overview__section-header wow fadeInUp" data-wow-delay=".2s" style={{ textAlign: 'center', marginBottom: '50px' }}>
                        <p className="vrm-overview__eyebrow" style={{ color: '#3B4ECC', fontWeight: '700', textAlign: 'center', margin: '0 auto', display: 'block' }}>Products Highlight</p>
                        <h2 className="title" style={{ textAlign: 'center', margin: '0 auto' }}>Enterprise AI Solutions Built on the WorkflowSI Platform</h2>
                    </div>
                    <div className="vrm-hero__cards--two-columns" style={{ marginBottom: '80px' }}>
                        {[
                            {
                                id: 1,
                                icon: "assets/images/service/icon/04.svg",
                                category: "Resume Intelligence",
                                title: "Xpress Screening",
                                desc: "AI-powered resume screening that identifies, ranks, and matches the best candidates with speed and precision.",
                                link: "/products/workflow/xpress-screening",
                                bgImage: "assets/images/workflow/xpress-screening/xpress-screening-image.webp"
                            },
                            {
                                id: 2,
                                icon: "assets/images/service/icon/01.svg",
                                category: "Smart Assessment",
                                title: "ScreenSage",
                                desc: "Automated AI voice interviews that evaluate candidates and deliver structured hiring insights in real time.",
                                link: "/products/workflow/screensage",
                                bgImage: "assets/images/workflow/screensage/screensage-image.webp"
                            },
                            {
                                id: 3,
                                icon: "assets/images/service/icon/02.svg",
                                category: "Video Intelligence",
                                title: "VideoSage",
                                desc: "AI-driven video interviews that assess communication, confidence, and role readiness through intelligent analysis.",
                                link: "/products/workflow/videosage",
                                bgImage: "assets/images/workflow/videosage/videosage-image-3.webp"
                            },
                            {
                                id: 4,
                                icon: "assets/images/service/icon/03.svg",
                                category: "Technical Evaluation",
                                title: "CodeSage",
                                desc: "AI-powered coding assessments with automated technical interviews, proctoring, and intelligent candidate evaluation in one unified platform.",
                                link: "/products/workflow/codesage",
                                bgImage: "assets/images/workflow/codesage/codesage-image.webp"
                            }
                        ].map((product) => (
                            <div key={product.id} className="vrm-product-card wow fadeInUp" data-wow-delay=".3s">
                                <div
                                    className="vrm-product-card-bg"
                                    style={{ backgroundImage: `url(${product.bgImage})` }}
                                ></div>
                                <div className="vrm-product-card__content">
                                    <div className="vrm-hero__icon">
                                        <img src={product.icon} alt={product.title} loading="lazy" />
                                    </div>
                                    <span style={{ 
                                        fontSize: '13px', 
                                        fontWeight: '700', 
                                        textTransform: 'uppercase', 
                                        color: '#3B4ECC', 
                                        letterSpacing: '1px', 
                                        display: 'block', 
                                        marginBottom: '8px' 
                                    }}>
                                        {product.category}
                                    </span>
                                    <h3>{product.title}</h3>
                                    <p>{product.desc}</p>
                                    <Link className="vrm-btn-detail" to={product.link}>
                                        Read More <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Standalone Products Section */}
                    <div className="vrm-overview__section-header wow fadeInUp" data-wow-delay=".2s" style={{ textAlign: 'center', marginBottom: '50px' }}>
                        <p className="vrm-overview__eyebrow" style={{ color: '#3B4ECC', fontWeight: '700', textAlign: 'center', margin: '0 auto', display: 'block' }}>Dedicated Engines</p>
                        <h2 className="title" style={{ textAlign: 'center', margin: '0 auto' }}>Specialized AI Solutions for Real Estate, Workforce & Customer Engagement</h2>
                    </div>
                    <div className="vrm-hero__cards--two-columns">
                        {[
                            {
                                id: 6,
                                icon: "assets/images/service/icon/02.svg",
                                category: "Citizen Engagement",
                                title: "People Connect (Global)",
                                desc: "AI-powered citizen engagement platform connecting governments and communities through intelligent digital services.",
                                link: "/products/people-connect",
                                bgImage: "assets/images/people-connect/people-connect-image.webp"
                            },
                            {
                                id: 5,
                                icon: "assets/images/service/icon/04.svg",
                                category: "Interactive Voice Training",
                                title: "SI Buddy",
                                desc: "An intelligent AI language coach that helps users learn, practice, and communicate naturally in multiple languages with personalized AI coaching.",
                                link: "/products/sibuddy",
                                bgImage: "assets/images/aibuddy/aibuddy-image.webp"
                            },
                            {
                                id: 7,
                                icon: "assets/images/service/icon/01.svg",
                                category: "HR Offboarding",
                                title: "Exit Intelligence",
                                desc: "Transform employee exits into actionable workforce insights with AI-powered interviews and sentiment analysis.",
                                link: "/products/exitinterview",
                                bgImage: "assets/images/exitinterview/exitinterview-image.webp"
                            },
                            {
                                id: 9,
                                icon: "assets/images/service/icon/02.svg",
                                category: "Visual Intelligence",
                                title: "Visionix SI",
                                desc: "Automate visual authentication, security tracking, and attendance management with Visionix SI face recognition engine.",
                                link: "/products/visionix",
                                bgImage: "assets/images/visionix/visionix-image.webp"
                            },
                            {
                                id: 10,
                                icon: "assets/images/service/icon/01.svg",
                                category: "PropTech & Real Estate CRM",
                                title: "VRM Reality",
                                desc: "Smart real estate platform connecting buyers, sellers, and agents with map search, virtual Zoom visits, and built-in agent CRM.",
                                link: "/products/vrm-reality",
                                bgImage: "assets/images/vrm-reality/vrm-reality-hero.webp"
                            },
                            {
                                id: 11,
                                icon: "assets/images/service/icon/03.svg",
                                category: "Talent Deployment AI",
                                title: "Bench to Deploy (B2D)",
                                desc: "AI-powered platform that evaluates, upskills, and matches unassigned bench talent into active billing.",
                                link: "/products/bench-to-deploy",
                                bgImage: "assets/images/bench-to-deploy/b2d-team.webp"
                            }
                        ].map((product) => (
                            <div key={product.id} className="vrm-product-card wow fadeInUp" data-wow-delay=".3s">
                                <div className="vrm-product-card-bg">
                                    <img src={product.bgImage} 
                                        alt={product.title} 
                                        width="600"
                                        height="600"
                                        decoding="async"
                                        loading="lazy"
                                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} 
                                    />
                                </div>
                                <div className="vrm-product-card__content">
                                    <div className="vrm-hero__icon">
                                        <img src={product.icon} alt={product.title} loading="lazy" />
                                    </div>
                                    <span style={{ 
                                        fontSize: '13px', 
                                        fontWeight: '700', 
                                        textTransform: 'uppercase', 
                                        color: '#3B4ECC', 
                                        letterSpacing: '1px', 
                                        display: 'block', 
                                        marginBottom: '8px' 
                                    }}>
                                        {product.category}
                                    </span>
                                    <h3>{product.title}</h3>
                                    <p>{product.desc}</p>
                                    <Link className="vrm-btn-detail" to={product.link}>
                                        Read More <i className="fas fa-arrow-right"></i>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default HomeOverview;
